<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{$i18n.t('common.common_gameName_search') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_searchTopic') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.searchTopic) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfRequired') }}
            span(slot="value") {{ parameters.numOfUnknowns }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ parameters.numOfExamples }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
            span(slot="value") {{ parameters.tableSize }} x {{ parameters.tableSize }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
    }
</script>
